import React, { useState, useEffect, useRef } from 'react';
import Header from './Component/Header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faSort, faPlus, faMinus, faBars, faChevronRight, faArrowLeft, faImage } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from 'react-router-dom';
import FourSquares from './images/FourSquares.png';
import CartBag from './images/CartBag.png';
import ArrowLeft from './images/ArrowLeft.png';
import Microphone from './images/Microphone.png';
import Search from './images/Search.png';
import BucketEmptyConfirmPopup from './Component/BucketEmptyConfirmPopup';
import { useNotification } from '../context/NotificationContext';
import VoiceSearchModal from './Component/VoiceSearchModal';
// Import category images
import TileAllied from './images/tileallied.png';
import GroutEpoxy from './images/GroutEpoxy.png';
import Adhesives from './images/Adhesives.png';
import Snackbar from './Component/Snackbar';
import ViewBucket from './Component/ViewBucket';

const ProductDetails = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('main');
  const [quantities, setQuantities] = useState({});
  const [menuOpen, setMenuOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true); // Set to true initially
  const [productSubcategories, setProductSubcategories] = useState([]);
  const [retryCount, setRetryCount] = useState(0);
  const RETRY_LIMIT = 3;
  const [activeInput, setActiveInput] = useState(null);
  const inputRefs = useRef({});
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const roleId = sessionStorage.getItem('roleId');
  const hubId = sessionStorage.getItem('hubId');
  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES;
  const [categories, setCategories] = useState([]);
  const ecommerceCategories = categories.filter(cat => cat.is_ecommerce === true);
  const ecommerceCategoryIds = ecommerceCategories.map(cat => cat._id);
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState('');
  const { projectId, project, categoryId, categoryName } = location.state || {};
  const [snackbarState, setSnackbarState] = useState({
    show: true,
    minimized: false
  });
  const { notifications, setNotifications } = useNotification();
  const [isSnackbarVisible, setIsSnackbarVisible] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);

  if (project) {
    sessionStorage.setItem('project', JSON.stringify(project));
  }

  const bucketRef = useRef(null);
  const imgRefs = useRef({});
  const [bucketImages, setBucketImages] = useState({});

  const [showVoiceModal, setShowVoiceModal] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [showEmptyBucketPopup, setShowEmptyBucketPopup] = useState(false);
  const [pendingRemoveProductId, setPendingRemoveProductId] = useState(null);

  const menuRef = useRef(null);
  const [productCategories, setProductCategories] = useState([]);

  // Functions to control snackbar state
  const minimizeSnackbar = () => {
    setSnackbarState(prev => ({ ...prev, minimized: true }));
  };

  const expandSnackbar = () => {
    setSnackbarState(prev => ({ ...prev, minimized: false }));
  };

  const hideSnackbar = () => {
    setSnackbarState({ show: false, minimized: false });
  };

  useEffect(() => {
    fetchCategories();
  }, []);

 useEffect(() => {
  const loadData = async () => {
    if (categories.length === 0) return;

    try {
      const ecommerceCategoryIds = categories.map(cat => cat._id);

      const productsData = await fetchProductsByCategoryIds(ecommerceCategoryIds);
      setProducts(productsData);

      await fetchSubcategoriesByCategoryIds(ecommerceCategoryIds);

    } catch (error) {
      console.error("Error loading data:", error);
    }
  };

  loadData();
}, [categories]);



  // Add search effect with loading
  // useEffect(() => {
  //   if (searchTerm.trim() !== '') {
  //     // Simulate search delay for better UX
  //     const searchTimeout = setTimeout(() => {
  //       setSearchLoading(false);
  //     }, 300);

  //     return () => clearTimeout(searchTimeout);
  //   } else {
  //     setSearchLoading(false);
  //   }
  // }, [searchTerm]);

  useEffect(() => {
    // Change from sessionStorage to localStorage
    const savedQuantities = localStorage.getItem('bucketQuantities');
    if (savedQuantities) {
      setQuantities(JSON.parse(savedQuantities));
    } else {
      setQuantities({});
    }

    const savedBucketImages = localStorage.getItem('bucketImages');
    if (savedBucketImages) {
      setBucketImages(JSON.parse(savedBucketImages));
    } else {
      setBucketImages({});
    }
  }, []);

  const handleMicClick = () => {
    setShowVoiceModal(true);
  };

  const handleVoiceResult = (transcript) => {
    setSearchTerm(transcript);
  };

  const fetchSubcategoriesByCategoryIds = async (categoryIds) => {
    try {
    setLoading(true);    
   const token = sessionStorage.getItem('token');
      const categoryIdsParam = categoryIds.join(',');
      const response = await fetch(`${fetchUrl}product-sub-category/get-subcategories-by-category-ids?categoryIds=${categoryIdsParam}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        }
      });
      const data = await response.json();
      console.log('Fetched subcategories for multiple categories:', data);
      if (data.success) {
        setProductSubcategories(data.data || []);
      } else {
        setProductSubcategories([]);
      }
    } catch (error) {
      console.error("Error fetching subcategories for multiple categories:", error);
    }
    finally {
    setLoading(false); 
  }
  };

  const fetchCategories = async () => {
    try {
      setLoading(true);
      const response = await fetch(fetchUrl + "product-category/get-all-productCategories?is_ecommerce=true", {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      const data = await response.json();
      console.log('Fetched categories:', data);

      if (data.success) {
        setCategories(data.data);
      } else {
        console.error('Failed to fetch categories:', data.message);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
    finally {
      setLoading(false);
    }
  };

  const fetchProductsByCategoryIds = async (categoryIds) => {
    const response = await fetch(fetchUrl + "product/get-products-by-category-ids", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ categoryIds })
    });
    const data = await response.json();
    console.log('Fetched products by category IDs:', data);
    if (data.success) {
      return data.data;
    }
    return [];
  };

  // Rest of your existing functions (toggleMenu, handleHomeClick, etc.) remain the same...
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleHomeClick = () => {
    window.location.href = '/consumer/projectDetails';
  };

  // Handle clicks outside the menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuOpen]);

  const handleQuantityChange = (productId, action) => {
    if (action === 'increase') {
      setQuantities(prev => {
        const prevQty = prev[productId] || 0;
        const newQuantities = {
          ...prev,
          [productId]: prevQty + 1
        };
        localStorage.setItem('bucketQuantities', JSON.stringify(newQuantities));

        // Always update bucket products with category info
        const currentBucketProducts = JSON.parse(localStorage.getItem('bucketProducts') || '{}');
        const product = products.find(p => p._id === productId);
        if (product) {
          // Find category name for this product
          const productCategory = ecommerceCategories.find(cat => cat._id === product.product_category_id);
          currentBucketProducts[productId] = {
            ...product,
            category: categoryName, // Add category name
            categoryId: product.product_category_id // Add category ID
          };
          localStorage.setItem('bucketProducts', JSON.stringify(currentBucketProducts));
        }

        // Only do flying animation for new items
        if (prevQty === 0) {
          // Flying animation code (keep as is)
          setTimeout(() => {
            if (imgRefs.current[productId] && bucketRef.current) {
              const fromRect = imgRefs.current[productId].getBoundingClientRect();
              const toRect = bucketRef.current.getBoundingClientRect();

              const flyingImg = document.createElement('img');
              flyingImg.src = `${imageUrl}${product?.product_image}`;
              flyingImg.className = 'fixed z-50 w-12 h-12 object-contain bg-white rounded-full shadow-xl border-2 border-red-400 pointer-events-none';

              flyingImg.style.top = `${fromRect.top + fromRect.height / 2 - 24}px`;
              flyingImg.style.left = `${fromRect.left + fromRect.width / 2 - 24}px`;
              flyingImg.style.transition = 'all 0.9s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
              flyingImg.style.zIndex = '9999';

              document.body.appendChild(flyingImg);

              setTimeout(() => {
                flyingImg.style.top = `${toRect.top + toRect.height / 2 - 12}px`;
                flyingImg.style.left = `${toRect.left + toRect.width / 2 - 12}px`;
                flyingImg.style.transform = 'scale(0.5)';
                flyingImg.style.opacity = '0.3';
              }, 100);

              setTimeout(() => {
                setBucketImages(prev => {
                  const newBucketImages = {
                    ...prev,
                    [productId]: true
                  };
                  localStorage.setItem('bucketImages', JSON.stringify(newBucketImages));
                  return newBucketImages;
                });

                if (document.body.contains(flyingImg)) {
                  document.body.removeChild(flyingImg);
                }
              }, 1000);
            }
          }, 100);
        }

        return newQuantities;
      });
    } else if (action === 'decrease') {
      // Rest of your decrease logic remains the same
      const currentQty = quantities[productId] || 0;

      if (currentQty === 1) {
        setPendingRemoveProductId(productId);
        setShowEmptyBucketPopup(true);
      } else if (currentQty > 1) {
        performDecrease(productId);
      }
    }
  };




  const performDecrease = (productId) => {
    setQuantities(prev => {
      const newQty = Math.max(0, (prev[productId] || 0) - 1);
      const newQuantities = { ...prev, [productId]: newQty };
      localStorage.setItem('bucketQuantities', JSON.stringify(newQuantities));

      if (newQty === 0) {
        setBucketImages(prev => {
          const newBucketImages = { ...prev };
          delete newBucketImages[productId];
          localStorage.setItem('bucketImages', JSON.stringify(newBucketImages));
          return newBucketImages;
        });

        const currentBucketProducts = JSON.parse(localStorage.getItem('bucketProducts') || '{}');
        delete currentBucketProducts[productId];
        localStorage.setItem('bucketProducts', JSON.stringify(currentBucketProducts));
      }

      return newQuantities;
    });
  };

  const handleConfirm = () => {
    if (pendingRemoveProductId) {
      performDecrease(pendingRemoveProductId);
    }
    setShowEmptyBucketPopup(false);
    setPendingRemoveProductId(null);
  };

  const getTotalItems = () => {
    return Object.values(quantities).reduce((total, quantity) => total + quantity, 0);
  };

  const handleViewBucket = () => {
    const selectedProducts = Object.keys(quantities)
      .filter(productId => quantities[productId] > 0)
      .map(productId => {
        const product = products.find(p => p._id === productId);
        if (!product) return null;

        // Find category name using product_category_id from categories state
        const productCategory = categories.find(cat => cat._id === product.product_category_id);

        return {
          id: product._id,
          name: product.product_name,
          price: product.selling_price,
          quantity: quantities[productId],
          image: product.product_image || '',
          UOM_id: product.UOM_id, 
          categoryId: product.product_category_id,
          vendorId: product.vendor_id,
        };
        
      })
      
      .filter(product => product !== null);

    localStorage.setItem('cartItems', JSON.stringify(selectedProducts));
    console.log('selectedProducts', selectedProducts);

    navigate('/consumer/cartPreview', {
      state: {
        projectId: projectId,
        project: project
      }
    });
  };





  const getSubcategoryImage = (subcategory) => {
    const name = subcategory.product_sub_category_name.toLowerCase();
    if (name.includes('grout') || name.includes('epoxy')) {
      return GroutEpoxy;
    } else if (name.includes('adhesive')) {
      return Adhesives;
    } else {
      return TileAllied;
    }
  };

  const getFilteredProducts = () => {
    if (activeTab === 'main') {
      return products;
    } else {
      return products.filter(product => product.product_sub_category_id === activeTab);
    }
  };

  const filteredProducts = getFilteredProducts();

  const handleSnackbarVisibilityChange = (isVisible) => {
    setIsSnackbarVisible(isVisible);
  };

  // Show skeleton loader when loading

 // Show loader while fetching data
if (loading) {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center  bg-opacity-70 backdrop-blur-sm z-50">
      <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
      
      {/* Text below loader */}
      <p className="mt-4 text-gray-400 text-xs">Loading Categories...</p>
    </div>
  );
}

  


  
  

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <div className='border-b border-gray-300 '>
        <div className="px-2 bg-white py-3 flex justify-between items-center sticky top-0 z-30">
          <div className="flex items-center">
            <button onClick={() => navigate('/consumer/projectdetails')} className="text-gray-700 p-1 hover:bg-gray-100 rounded-md">
              <img
                src={ArrowLeft}
                alt="Back"
                className="w-10 h-6"
              />
            </button>
            <h2 className="text-sm font-medium text-[#000000]">QuickBuy</h2>
          </div>
        </div>
      </div>

      {/* Search Bar */}
      <div className="px-6 pt-6 pb-3 bg-white sticky top-0 z-20 mb-2">
        <div className="relative max-w-xl mx-auto">
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400 text-lg">
            <img
              src={Search}
              alt="Search"
              className="h-6 w-6"
            />
          </span>
          <input
            type="text"
            placeholder={isListening ? 'Listening...' : 'Search "product name" or say it'}
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            className={`w-full pl-12 pr-12 py-3 rounded-md border text-sm font-medium focus:outline-none focus:ring-0 ${isListening
              ? 'border-red-400 focus:border-red-400'
              : 'border-gray-300 focus:border-gray-300'
              }`}
            disabled={isListening}
          />

          <button
            onClick={searchTerm ? () => setSearchTerm('') : handleMicClick}
            className={`absolute inset-y-0 right-0 flex items-center pr-3 focus:outline-none transition-all duration-200 ${isListening ? 'animate-pulse' : 'hover:scale-110'
              }`}
            disabled={isListening && searchTerm === ''}
          >
            {searchTerm ? (
              <div className="w-5 h-5 bg-gray-400 rounded-full flex items-center justify-center hover:bg-gray-500 transition-colors">
                <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
            ) : (
              <div className="relative">
                <img
                  src={Microphone}
                  alt="Voice Search"
                  className={`w-6 h-8 transition-all duration-200 ${isListening ? 'filter brightness-0 saturate-100 invert-27 sepia-98 saturate-7495 hue-rotate-3 brightness-100 contrast-102' : ''
                    }`}
                />
                {isListening && (
                  <div className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-ping"></div>
                )}
              </div>
            )}
          </button>

          {isListening && (
            <div className="absolute -bottom-8 left-1/2 transform -translate-x-1/2">
              <div className="flex items-center space-x-2 bg-red-500 text-white px-3 py-1 rounded-full text-xs">
                <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                <span>Listening...</span>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Main Content */}
   {!loading &&  (
  <div className="flex-1 px-4 mb-6">
    {/* Search Results */}
    {searchTerm.trim() !== '' ? (
      products.filter(product =>
        product.product_name.toLowerCase().includes(searchTerm.toLowerCase())
      ).length > 0 ? (
        <div className="px-2 py-4 pb-10 bg-white">
          <div className="grid grid-cols-2 gap-4">
            {products
              .filter(product =>
                product.product_name.toLowerCase().includes(searchTerm.toLowerCase())
              )
              .map(product => {
                const quantity = quantities[product._id] || 0;
                return (
                  <div key={product._id} className="flex flex-col">
                    <div className="rounded-xl bg-[#F5F5F5] overflow-hidden mb-3 relative pb-12">
                      <div className="h-28 flex items-center justify-center p-3">
                        {product.product_image ? (
                          <img
                            ref={el => (imgRefs.current[product._id] = el)}
                            src={`${imageUrl}${product.product_image}`}
                            alt={product.product_name}
                            className="h-full w-full object-contain cursor-pointer hover:scale-105 transition-transform duration-200"
                            onClick={() =>
                              navigate('/consumer/productInformation', {
                                state: {
                                  product: product,
                                  relatedProducts: products.filter(p =>
                                    p.product_name.toLowerCase().includes(searchTerm.toLowerCase())
                                  ),
                                  searchTerm: searchTerm,
                                  isFromSearch: true,
                                  allProducts: products,
                                  ecommerceCategories: ecommerceCategories
                                }
                              })
                            }
                          />
                        ) : (
                          <div
                            className="h-full w-full flex items-center justify-center text-center text-gray-500 text-sm cursor-pointer"
                            onClick={() =>
                              navigate('/consumer/productInformation', {
                                state: {
                                  product: product,
                                  relatedProducts: products.filter(p =>
                                    p.product_name.toLowerCase().includes(searchTerm.toLowerCase())
                                  ),
                                  searchTerm: searchTerm,
                                  isFromSearch: true,
                                  allProducts: products,
                                  ecommerceCategories: ecommerceCategories
                                }
                              })
                            }
                          >
                            {product.product_name}
                          </div>
                        )}
                      </div>

                      <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2">
                        {quantity === 0 ? (
                          <button
                            onClick={() => handleQuantityChange(product._id, 'increase')}
                            className="text-xs text-[#D93025] bg-white border border-red-500 rounded-md px-6 py-1 font-semibold hover:bg-red-50 transition"
                          >
                            Add
                          </button>
                        ) : (
                          <div className="flex items-center justify-between bg-white border-2 border-red-500 rounded-md px-3 py-1">
                            <button
                              onClick={() => handleQuantityChange(product._id, 'decrease')}
                              className="w-5 h-5 flex items-center justify-center text-red-500 text-sm font-bold"
                            >
                              −
                            </button>
                            <span className="text-sm text-gray-900 font-medium mx-3">{quantity}</span>
                            <button
                              onClick={() => handleQuantityChange(product._id, 'increase')}
                              className="w-5 h-5 flex items-center justify-center text-red-500 text-sm font-bold"
                            >
                              +
                            </button>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Product Info */}
                    <div className="flex flex-col items-start">
                      <h3 className="text-xs text-[#000000] mb-1 line-clamp-2 leading-snug text-left">
                        {product.product_name}
                      </h3>
                      <p className="text-xs text-[#170101] font-semibold">
                        ₹{product.selling_price.toLocaleString()}
                      </p>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-start mt-6 px-4">
          <img
            src={CartBag}
            alt="No products found"
            className="w-24 h-24 object-contain mb-1 opacity-60"
          />
          <h3 className="text-center text-xl font-semibold text-gray-600 mb-1">Sorry!</h3>
          <div className="text-center text-gray-500 text-sm">
            Currently we don't have "{searchTerm}" available with us.
          </div>
        </div>
      )
    ) : (
      <>
        {/* Categories Section when search is empty */}
        <div className="flex items-center justify-between mb-4 px-2">
          <div className="flex items-center space-x-2">
            <img src={FourSquares} alt="Section Icon" className="w-6 h-8" />
            <h2 className="text-xl font-semibold text-[#170101]">Categories</h2>
          </div>
          {/* <button
            onClick={() => navigate('/consumer/productcategories')}
            className="text-sm text-[#1A73E7] font-semibold hover:underline"
          >
            View All
          </button> */}
        </div>

        {/* Empty state if no categories */}
        {ecommerceCategories.length === 0 ? (
          <div className="text-gray-500">No e-commerce categories found.</div>
        ) : (
          ecommerceCategories.map(cat => (
            <div key={cat._id} className="mb-10">
              {/* Category Header */}
              <div className="flex justify-between items-center mb-4 px-3">
                <span className="text-lg text-[#000000] font-semibold">
                  {cat.product_category_name}
                </span>
                <button
                  onClick={() =>
                    navigate('/consumer/productlist', {
                      state: { categoryId: cat._id, categoryName: cat.product_category_name },
                    })
                  }
                  className="text-gray-400 hover:text-gray-600"
                >
                  <FontAwesomeIcon icon={faChevronRight} className="text-sm" />
                </button>
              </div>

              {/* Subcategory Grid */}
        <div className="overflow-x-auto px-3 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
  <div className="flex space-x-4">
    {productSubcategories
      .filter(sub => sub.product_category_id === cat._id)
      .map(sub => (
        <div
          key={sub._id}
          className="flex-shrink-0 w-28 bg-[#F5F5F5] px-3 py-3 rounded-lg flex flex-col items-center text-center cursor-pointer hover:bg-gray-200 transition-colors"
          onClick={() =>
            navigate('/consumer/productlist', {
              state: {
                categoryId: cat._id,
                categoryName: cat.product_category_name,
                subcategoryId: sub._id,
                subcategoryName: sub.product_sub_category_name
              }
            })
          }
        >
          {sub.product_sub_category_image ? (
            <div className="w-16 h-16 flex items-center justify-center rounded-md mb-2 overflow-hidden">
              <img
                src={`${imageUrl}${sub.product_sub_category_image}`}
                alt={sub.product_sub_category_name}
                className="object-contain h-full w-auto"
              />
            </div>
          ) : (
            <div className="w-16 h-16 flex items-center justify-center rounded-md mb-2 bg-white">
              <FontAwesomeIcon
                icon={faImage}
                className="text-2xl text-gray-400 opacity-40"
              />
            </div>
          )}
          <span className="text-[11px] font-medium text-gray-800 line-clamp-2 leading-snug">
            {sub.product_sub_category_name}
          </span>
        </div>
      ))}
  </div>
</div>


            </div>
          ))
        )}
      </>
    )}
  </div>
)}


      {/* View Bucket Component */}
      <ViewBucket
        quantities={quantities}
        bucketImages={bucketImages}
        products={products}
        bucketProducts={{}}
        imageUrl={imageUrl}
        bucketRef={bucketRef}
        onViewBucket={handleViewBucket}
        navigationState={{
          state: {
            projectId: projectId,
            project: project
          }
        }}
      />

      {/* Popups and Modals */}
      <BucketEmptyConfirmPopup
        isOpen={showEmptyBucketPopup}
        onClose={() => setShowEmptyBucketPopup(false)}
        onConfirm={handleConfirm}
        productName={
          pendingRemoveProductId
            ? products.find(p => p._id === pendingRemoveProductId)?.product_name || "this item"
            : "this item"
        }
      />

      <VoiceSearchModal
        isOpen={showVoiceModal}
        onClose={() => setShowVoiceModal(false)}
        onResult={handleVoiceResult}
      />


      {/* Replace the existing <style jsx> with this: */}
      <style>{`
  .hide-scrollbar::-webkit-scrollbar {
    display: none;
  }
  .hide-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .line-clamp-1 {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`}</style>

    </div>
  );
};

export default ProductDetails;

